import crudApi from "@serie3/common/api/crudApi";
import SocialEndpoints from "@serie3/mymediaplanner/Modules/Social/endpoints";
import listHandler from "@serie3/common/Domain/listHandler";
import AddButton from "../../../shared/Buttons/AddButton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWandMagicSparkles } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";

const AddBtn = ({
  posts,
  setPosts,
  setShowPostAssistant,
  setEditPost,
  setShowEdit,
}) => {
  const { t } = useTranslation();
  return (
    <>
      <button
        type="button"
        onClick={() => setShowPostAssistant(true)}
        title={t("Backend.Post.AIPost")}
        style={{
          padding: "6px 14px", borderRadius: 50, border: "none",
          background: "linear-gradient(135deg,#564ab1,#3d3490)",
          color: "#fff", fontSize: 13, fontWeight: 600, cursor: "pointer",
          display: "flex", alignItems: "center", gap: 6,
          boxShadow: "0 3px 10px rgba(86,74,177,0.3)",
        }}
      >
        <FontAwesomeIcon icon={faWandMagicSparkles} style={{ fontSize: 12 }} />
        <span className="d-none d-sm-inline">{t("Backend.Post.AIPost")}</span>
      </button>
      <AddButton
        addFunction={async () => {
          let response = await crudApi.createNew(SocialEndpoints.posts.new, {});
          if (response.ok) {
            listHandler.newToList(response, posts, setPosts, null, true);
            setEditPost(response.data);
            setShowEdit(true);
          }
        }}
      />
    </>
  );
};

export default AddBtn;
